var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: [_vm.block, _vm.isOpen ? "-open" : "-closed"],
      attrs: {
        "aria-expanded": `${_vm.isOpen}`,
        "aria-controls": _vm.id,
        tabindex: "0",
        role: "button",
      },
      on: { click: _vm.open },
    },
    [
      _c(
        "div",
        {
          class: `${_vm.block}__${_vm.headerElement}`,
          attrs: { id: `${_vm.id}-control` },
        },
        [
          _vm._t("heading"),
          _vm._v(" "),
          _vm._t("icon", function () {
            return [
              _vm.isOpen
                ? _c(
                    "svg",
                    {
                      class: `${_vm.block}__icon`,
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 448 512",
                      },
                    },
                    [
                      _c(
                        "path",
                        {
                          attrs: {
                            d: "M432 256C432 269.3 421.3 280 408 280H40c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h368C421.3 232 432 242.8 432 256z",
                          },
                        },
                        [_c("title", [_vm._v("Menu")])]
                      ),
                    ]
                  )
                : _c(
                    "svg",
                    {
                      class: `${_vm.block}__icon`,
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 448 512",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 \n                440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 \n                58.75 248 72v160h160C421.3 232 432 242.8 432 256z",
                        },
                      }),
                    ]
                  ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "accordion__transition" },
          on: {
            enter: _vm.startTransition,
            "after-enter": _vm.endTransition,
            "before-leave": _vm.startTransition,
            "after-leave": _vm.endTransition,
          },
        },
        [
          _vm.isOpen
            ? _c(
                "div",
                {
                  ref: "content",
                  class: `${_vm.block}__${_vm.contentElement}`,
                  attrs: { id: _vm.id, "aria-labelledby": `${_vm.id}-control` },
                },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }